export const language = [
  //   {
  //     displayName: "English",
  //     countryCode: "en",
  //     alpha2Code: ["GB", "US", "AU", "CA"],
  //     value: "en",
  //   },
  {
    displayName: "Arabic",
    countryCode: "ar",
    alpha2Code: ["AE", "SA", "EG", "KW"],
    value: "ar",
  },
  {
    displayName: "Azerbaijani",
    countryCode: "az",
    alpha2Code: ["AZ"],
    value: "az",
  },
  {
    displayName: "Bosnian",
    countryCode: "bs",
    alpha2Code: ["BA"],
    value: "bs",
  },
  {
    displayName: "Catalan",
    countryCode: "ca",
    alpha2Code: ["ES"],
    value: "ca",
  },
  {
    displayName: "Chinese (Simplified)",
    countryCode: "zh-Hans",
    alpha2Code: ["CN", "SG"],
    value: "zh-Hans",
  },
  {
    displayName: "Chinese (Traditional)",
    countryCode: "zh-Hant",
    alpha2Code: ["TW", "HK"],
    value: "zh-Hant",
  },
  {
    displayName: "Croatian",
    countryCode: "hr",
    alpha2Code: ["HR"],
    value: "hr",
  },
  { displayName: "Czech", countryCode: "cs", alpha2Code: ["CZ"], value: "cs" },
  { displayName: "Danish", countryCode: "da", alpha2Code: ["DK"], value: "da" },
  {
    displayName: "Dutch",
    countryCode: "nl",
    alpha2Code: ["NL", "BE"],
    value: "nl",
  },
  {
    displayName: "Estonian",
    countryCode: "et",
    alpha2Code: ["EE"],
    value: "et",
  },
  {
    displayName: "Finnish",
    countryCode: "fi",
    alpha2Code: ["FI"],
    value: "fi",
  },
  {
    displayName: "French",
    countryCode: "fr",
    alpha2Code: ["FR", "CA", "BE", "CH"],
    value: "fr",
  },
  {
    displayName: "Georgian",
    countryCode: "ka",
    alpha2Code: ["GE"],
    value: "ka",
  },
  {
    displayName: "Bulgarian",
    countryCode: "bg",
    alpha2Code: ["BG"],
    value: "bg",
  },
  {
    displayName: "German",
    countryCode: "de",
    alpha2Code: ["DE", "AT", "CH"],
    value: "de",
  },
  {
    displayName: "Greek",
    countryCode: "el",
    alpha2Code: ["GR", "CY"],
    value: "el",
  },
  { displayName: "Hindi", countryCode: "hi", alpha2Code: ["IN"], value: "hi" },
  { displayName: "Hebrew", countryCode: "he", alpha2Code: ["IL"], value: "he" },
  {
    displayName: "Hungarian",
    countryCode: "hu",
    alpha2Code: ["HU"],
    value: "hu",
  },
  {
    displayName: "Indonesian",
    countryCode: "id",
    alpha2Code: ["ID"],
    value: "id",
  },
  {
    displayName: "Italian",
    countryCode: "it",
    alpha2Code: ["IT", "CH"],
    value: "it",
  },
  {
    displayName: "Japanese",
    countryCode: "ja",
    alpha2Code: ["JP"],
    value: "ja",
  },
  { displayName: "Korean", countryCode: "ko", alpha2Code: ["KR"], value: "ko" },
  {
    displayName: "Latvian",
    countryCode: "lv",
    alpha2Code: ["LV"],
    value: "lv",
  },
  {
    displayName: "Lithuanian",
    countryCode: "lt",
    alpha2Code: ["LT"],
    value: "lt",
  },
  {
    displayName: "Malay",
    countryCode: "ms",
    alpha2Code: ["MY", "SG"],
    value: "ms",
  },
  {
    displayName: "Norwegian",
    countryCode: "nb",
    alpha2Code: ["NO"],
    value: "nb",
  },
  {
    displayName: "Persian",
    countryCode: "fa",
    alpha2Code: ["IR", "AF"],
    value: "fa",
  },
  { displayName: "Polish", countryCode: "pl", alpha2Code: ["PL"], value: "pl" },
  {
    displayName: "Portuguese",
    countryCode: "pt",
    alpha2Code: ["PT", "BR"],
    value: "pt",
  },
  {
    displayName: "Punjabi",
    countryCode: "pa",
    alpha2Code: ["PK", "IN"],
    value: "pa",
  },
  {
    displayName: "Romanian",
    countryCode: "ro",
    alpha2Code: ["RO"],
    value: "ro",
  },
  {
    displayName: "Russian",
    countryCode: "ru",
    alpha2Code: ["RU", "BY", "KZ"],
    value: "ru",
  },
  {
    displayName: "Serbian",
    countryCode: "sr",
    alpha2Code: ["RS", "BA"],
    value: "sr",
  },
  { displayName: "Slovak", countryCode: "sk", alpha2Code: ["SK"], value: "sk" },
  {
    displayName: "Spanish",
    countryCode: "es",
    alpha2Code: ["ES", "MX", "AR", "CO"],
    value: "es",
  },
  {
    displayName: "Swedish",
    countryCode: "sv",
    alpha2Code: ["SE"],
    value: "sv",
  },
  { displayName: "Thai", countryCode: "th", alpha2Code: ["TH"], value: "th" },
  {
    displayName: "Turkish",
    countryCode: "tr",
    alpha2Code: ["TR"],
    value: "tr",
  },
  {
    displayName: "Ukrainian",
    countryCode: "uk",
    alpha2Code: ["UA"],
    value: "uk",
  },
  {
    displayName: "Vietnamese",
    countryCode: "vi",
    alpha2Code: ["VN"],
    value: "vi",
  },
];
